<template>
  <v-container
    fluid
    fill-height
    style="padding: 0; margin: 0"
    class="gradient-bg"
  >
    <v-snackbar top :color="snackbar.color" v-model="snackbar.model">{{
      snackbar.msg
    }}</v-snackbar>

    <v-row style="height: 100%" no-gutters>
      <v-col cols="12">
        <v-row justify="center" no-gutters>
          <v-col cols="12" class="mx-auto d-flex justify-center mt-12 mb-6">
            <div>
              <Logo :width="180" :filename="`logo-white.svg`" />
            </div>
          </v-col>

          <v-col cols="12" md="5">
            <!-- forgot form -->
            <v-card style="width: 90%" class="mx-auto pa-8" v-if="!isResetForm">
              <template v-if="!isTokenSent">
                <v-list-item class="text-center">
                  <v-list-item-content>
                    <v-list-item-title class="mb-3">
                      <h2 style="color: #1b3665">Forgot Password</h2>
                    </v-list-item-title>
                    <p>
                      Enter the email address associated with your account and
                      we'll send you a token to reset your password.
                    </p>

                    <div class="d-flex justify-center my-2">
                      <v-radio-group v-model="forgotForm.userType" row>
                        <v-radio label="Organizer" value="organizer"></v-radio>
                        <v-radio label="Agent" value="agent"></v-radio>
                        <v-radio label="Voter" value="voter"></v-radio>
                      </v-radio-group>
                    </div>
                  </v-list-item-content>
                </v-list-item>

                <v-form
                  v-model="valid.forgot"
                  ref="forgotForm"
                  @submit.prevent="forgotPassword"
                >
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="forgotForm.email"
                        :rules="[rules.required, rules.email]"
                        v-bind="fieldProps2"
                        placeholder="Email"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-btn
                        :loading="loading.forgot"
                        type="submit"
                        v-bind="btnProps2"
                        class="primary"
                        block
                      >
                        continue
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>

                <div class="mt-10 text-center">
                  <v-btn
                    router
                    link
                    @click="$router.history.go(-1)"
                    outlined
                    v-bind="btnProps2"
                    block
                    color="primary"
                    class="mx-auto"
                    ><v-icon left>mdi-chevron-left</v-icon>go back</v-btn
                  >
                </div>
              </template>

              <template v-else>
                <v-list-item class="text-center">
                  <v-list-item-content>
                    <v-list-item-title class="mb-3">
                      <h2 style="color: #1b3665">Email Sent</h2>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <p class="text-center">
                  Please check your email account
                  <span>[{{ forgotForm.email }}]</span> for your password reset
                  link.
                </p>
                <div class="mt-10 text-center">
                  <v-btn
                    v-bind="btnProps2"
                    block
                    router
                    link
                    :to="{ name: 'Auth' }"
                    class="primary mx-auto"
                    ><v-icon left>mdi-home</v-icon> go back home</v-btn
                  >
                </div>
              </template>
            </v-card>

            <!-- reset form -->
            <v-card style="width: 90%" class="mx-auto pa-8" v-else>
              <template v-if="!isResetSuccess">
                <v-list-item class="text-center">
                  <v-list-item-content>
                    <v-list-item-title class="mb-3">
                      <h2 style="color: #1b3665">Reset Password</h2>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-form
                  v-model="valid.reset"
                  ref="resetForm"
                  @submit.prevent="resetPassword"
                >
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="resetForm.password"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        v-on:click:append="show = !show"
                        :type="show ? 'text' : 'password'"
                        :rules="[rules.required, rules.password.min]"
                        v-bind="fieldProps2"
                        placeholder="Password"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        v-model="cpassword"
                        :rules="confirmPasswordRule"
                        :append-icon="showcp ? 'mdi-eye' : 'mdi-eye-off'"
                        v-on:click:append="showcp = !showcp"
                        :type="showcp ? 'text' : 'password'"
                        v-bind="fieldProps2"
                        placeholder="Confirm Password"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-btn
                        :loading="loading.reset"
                        type="submit"
                        v-bind="btnProps2"
                        class="primary"
                        block
                      >
                        continue
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </template>

              <template v-else>
                <v-list-item class="text-center">
                  <v-list-item-content>
                    <v-list-item-title class="mb-3">
                      <h2 style="color: #1b3665">Password Changed</h2>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <p class="text-center">
                  Your password has been changed successfully.
                </p>

                <div class="mt-10 text-center">
                  <v-btn
                    v-bind="btnProps2"
                    router
                    link
                    block
                    :to="{ name: 'Auth' }"
                    class="primary mx-auto"
                    >sign in with new password</v-btn
                  >
                </div>
              </template>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { rules, fieldProps2, btnProps2, toSentenceCase } from "@/helpers";
import Logo from "@/components/Logo.vue";
import { mapActions } from "vuex";

export default {
  name: "Forgot",

  components: {
    Logo,
  },

  data: () => ({
    rules,
    fieldProps2,
    btnProps2,
    isResetForm: false,

    snackbar: {
      model: false,
      msg: "Error!",
    },

    valid: {
      forgot: true,
      reset: true,
    },

    loading: {
      forgot: false,
      reset: false,
    },

    forgotForm: {
      email: "",
      userType: "organizer",
    },

    resetForm: {
      token: "",
      password: "",
    },
    cpassword: "",

    show: false,
    showcp: false,

    isTokenSent: false,
    isResetSuccess: false,
  }),

  computed: {
    confirmPasswordRule() {
      return [
        (v) => !!v || "Please confirm your password",
        (v) => v === this.resetForm.password || "Passwords must match.",
      ];
    },
  },

  methods: {
    ...mapActions(["makeFetch"]),

    showSnackbar(event) {
      this.snackbar.msg = !event.pre ? toSentenceCase(event.msg) : event.msg;
      this.snackbar.color = event.color;
      this.snackbar.model = true;
    },

    async submit(path, method, loadingVar, data, token) {
      this.loading[loadingVar] = true;

      const reqData = {
        method: method,
        goTo: path,
      };

      !!data && (reqData.data = data);
      !!token && (reqData.useToken = token);

      const res = await this.makeFetch({ ...reqData })
        .catch(console.error)
        .finally(() => (this.loading[loadingVar] = false));

      if (!res) {
        this.showSnackbar({ msg: "Connection error!", color: "error" });
        return false;
      }

      this.showSnackbar({
        msg: res.success ? res.data.message : res.message,
        color: res.success ? "primary" : "error",
      });
      return res.success;
    },

    async forgotPassword() {
      if (!this.$refs.forgotForm.validate()) return;

      this.isTokenSent = await this.submit(
        `/user_reset_token?email=${this.forgotForm.email}&user_type=${this.forgotForm.userType}`,
        "get",
        "forgot"
      );
    },

    async resetPassword() {
      if (!this.$refs.resetForm.validate()) return;

      const { token, password } = this.resetForm;

      this.isResetSuccess = await this.submit(
        "/user_reset_password",
        "post",
        "reset",
        {
          password: password,
          password_confirmation: password,
        },
        token
      );
    },
  },

  mounted() {
    const token = this.$route.query.token;
    this.isResetForm = !!token;
    this.resetForm.token = token;
  },
};
</script>

<style scoped>
.gradient-bg {
  background-image: linear-gradient(#005cff, #2d9bfc, #3de0ff);
  background-size: cover;
}
</style>
